// extracted by css-extract-rspack-plugin
export default {"cls1":"TopBar-cls1_4yQ","cls2":"TopBar-cls2_fqt TopBar-cls1_4yQ"};